import(/* webpackMode: "eager" */ "C:\\Users\\62877\\Documents\\NAYVERA\\src\\app\\galeri-page\\page.tsx");
